export default styles = {
  backNavWrapperStyle: {marginTop: 65, height: 20, width: 50, position: 'fixed', top: 0, left: '10px', zIndex: 500}
};
